import React, { useEffect } from "react";
import SocietiesComponent from "./societies";
import { societyList } from "../../redux/slice/societyListSlice";
import { connect } from "react-redux";
import PageLoader from "../common/pageLoader";
import { societyStatus } from "../../redux/slice/societyStatusSlice";
import { dashboardSocietyCount } from "../../redux/slice/dashboardSocietyCountSlice";

const Societies = (props) => {
  const {
    societyListData,
    callsocietyListData,
    callsocietyStatusData,
    dashboardSocietyCountData,
    calldashboardSocietyCountData,
    
  } = props;
  const loading = societyListData.isLoading;

  const total_society_count =
  (dashboardSocietyCountData &&
    dashboardSocietyCountData.dashboardSocietyCountData &&
    dashboardSocietyCountData.dashboardSocietyCountData.data) ||
  null;

  useEffect(() => {
    calldashboardSocietyCountData();
  }, []);

  return (
    <>
      {loading && <PageLoader />}
      <SocietiesComponent
        societyListData={societyListData}
        callsocietyListData={callsocietyListData}
        callsocietyStatusData={callsocietyStatusData}
        total_society_count={total_society_count}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  societyListData: state.societyListData,
  dashboardSocietyCountData: state.dashboardSocietyCountData,
});

const mapDispatchToProps = (dispatch) => ({
  callsocietyListData: (filters) => dispatch(societyList(filters)),
  callsocietyStatusData: (data) => dispatch(societyStatus(data)),
  calldashboardSocietyCountData: () => dispatch(dashboardSocietyCount()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Societies);
